'use client';

import { ConfirmDialog } from '@andritzot/metris-web-ui/feedback/confirm-dialog';

type DeleteItemDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  confirmColor?: 'error' | 'primary' | 'warning';
};

const DeleteItemDialog = ({
  open,
  onClose,
  onConfirm,
  message = 'Remove this item?',
  title = 'Confirm removal',
  confirmLabel = 'Remove',
  cancelLabel = 'Cancel',
  loading,
  confirmColor,
}: DeleteItemDialogProps) => (
  <ConfirmDialog
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    message={message}
    title={title}
    confirmLabel={confirmLabel}
    cancelLabel={cancelLabel}
    loading={loading}
    confirmColor={confirmColor}
  />
);

export default DeleteItemDialog;
